<template>
  <div>
    <el-row>
      <el-col :span="18">
        <div style="margin-bottom: 10px;" v-if="info && info.merchant_website">
          <h3>{{info.business_name}}</h3>
          <p v-for="website in info.merchant_website.split(',')">{{website}}</p>
        </div>
        <span style="display:none">{{info}}</span>
      </el-col>
      <el-col :span="6" class="text-right" v-if="editable">
        <a @click="edit()">更改</a>
      </el-col>
    </el-row>
  </div>
</template>

<script>

export default {
  name: 'ProductList',
  props: ['editable', 'info'],
  components: {
  },
  data () {
    return {
      websiteList: []
    }
  },
  computed: {
    taskInfo () {
	    return this.$store.state.taskInfo
    }
  },
  created () {

  },
  methods: {
    edit () {
      this.taskInfo.editConfirmProduct = true
      this.$store.commit('updateTaskInfo', this.taskInfo)
      if (this.$route.query.order_id) {
        this.$router.push({ path: 'products' , query: Object.assign(
          this.$route.query
        )})
      } else {
        this.$router.push({ path: 'cart' , query: Object.assign(
          {
            business_name: this.info.business_name
          },
          this.$route.query
        )})
      }

    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h3 {
  line-height: 25px;
}

p {
  line-height: 18px;
  margin-bottom: 5px;
  color: #666666;
}

a {
  font-size: 16px;
  cursor: pointer;
  line-height: 25px;
}
</style>



// WEBPACK FOOTER //
// src/pages/publish_task/cart/ProductTitle.vue